export const DateFormat = {
  DateIT: 'dd/MM/yyyy HH:mm:ss',
  DateEN: 'yyyy/MM/dd HH:mm:ss',
  DateGE: 'yyyy/MM/dd HH:mm:ss',
  NONE: '',
};
